export interface BaseAccessByHour {
  sector: string;
  sucursal: string;
  tipo_acceso: 'perimetral' | 'interna';
}

export type BodyAccessByHour = BaseAccessByHour &
  (
    | {
        Tipo_consulta_BD: 'RANGO_DIAS';
        fecha_inicial: string;
        fecha_final: string;
        por_defecto?: string;
      }
    | {
        Tipo_consulta_BD: 'RANGO_MESES';
        mes_inicial: string;
        mes_final: string;
      }
    | {
        Tipo_consulta_BD: 'MES_ACTUAL';
        mes_actual: string;
      }
    | {
        Tipo_consulta_BD: 'MES_ANTERIOR';
        mes_anterior: string;
      }
    | {
        Tipo_consulta_BD: 'ANIO_ACTUAL';
        anio_actual: string;
      }
    | {
        Tipo_consulta_BD: 'ANIO_ANTERIOR';
        anio_anterior: string;
      }
  );

export interface ResponseAccessByHour {
  'public data': DataAccessByHour;
}

export interface DataAccessByHour {
  anio_base: string | number;
  accesos: AccessByHour[];
}

export interface AccessByHour {
  acceso?: string;
  camara?: string;
  fechas: HourData[];
  indicador: string;
  diferencia: number;
  porcentaje: string;
  total_visitantes: number;
  total_visitantes_anterior: number;
}

export interface HourData {
  Hora: string;
  Entradas: number;
  Comparación: number;
}
